/*
 * @Author: 陈力恒
 * @Date: 2022-03-17 19:33:41
 * @LastEditors: 陈力恒
 * @LastEditTime: 2022-04-12 15:11:06
 * @Description: file content
 */
import type {
  ISupplierUsersModel,
  ISupplierUsersStore,
} from '@monorepo/types/purchasing/supplierUser/supplierUser.types';

const initState: ISupplierUsersStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    sort_order: 'CREATED_DESC',
  },
};

const supplierUserStore: ISupplierUsersModel = {
  namespace: 'supplierUserStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default supplierUserStore;
